// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
// rem
import './responsive'
// 全局组件
import './components/common/index.js';
// 全局指令
import './js/app/directive/fdDirective.js';
// 全局过滤器
import './js/app/filter/fdFilter.js';
// 全局消息
import './js/app/message/fdMessage.js';
// 全局配置
import './js/config.js';
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer) 
import WXConfig from './js/wx.jsapi.js';
Vue.prototype.WXConfig = WXConfig;
// 全局方法类
import FdGlobal from './js/app/common/fdGlobal.js';
import mandMobile from 'mand-mobile'
import 'mand-mobile/lib/mand-mobile.css'
import './permission.js' 
Vue.use(mandMobile)
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

// 引入 Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vconsole from 'vconsole'
// let vcon = new Vconsole()
Vue.use(ElementUI);

// 开始时间
const startTime = new Date().getTime();
// 全局对象
window.fdGlobal = new FdGlobal();
Vue.config.productionTip = false;
window.fdGlobal.performance.start(startTime);
window.fdGlobal.performance.execute('【app start】:');
/* eslint-disable no-new */

new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',
    beforeCreate() {
        // 开始时间
        this.beforeCreateTime = window.fdGlobal.performance.getCurrentTime();
    },
    created() {
        window.fdGlobal.performance.execute('【app created】:', this.beforeCreateTime);
        window.fdGlobal.performance.execute('【app created】:');
    },
    mounted() {
        window.fdGlobal.performance.execute('【app mounted】:', this.beforeCreateTime);
        window.fdGlobal.performance.execute('【app mounted】:');
    }
});



// WEBPACK FOOTER //
// ./src/main.js